/** Gallery grid thumbs — keep originals intact. */

export const GALLERY_THUMB_MAX_EDGE = 480;
export const GALLERY_THUMB_QUALITY = 0.72;
export const GALLERY_THUMB_SKIP_BYTES = 80_000;

export async function createImageThumbnailBlob(
  source: Blob,
  maxEdge = GALLERY_THUMB_MAX_EDGE,
  quality = GALLERY_THUMB_QUALITY,
): Promise<Blob> {
  const bitmap = await createImageBitmap(source);
  try {
    const scale = Math.min(1, maxEdge / Math.max(bitmap.width, bitmap.height));
    const width = Math.max(1, Math.round(bitmap.width * scale));
    const height = Math.max(1, Math.round(bitmap.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Canvas indisponível para miniatura.');
    ctx.drawImage(bitmap, 0, 0, width, height);
    const blob = await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(
        (next) => (next ? resolve(next) : reject(new Error('Falha ao gerar miniatura.'))),
        'image/jpeg',
        quality,
      );
    });
    return blob;
  } finally {
    bitmap.close();
  }
}

export function shouldReuseOriginalAsThumb(blob: Blob): boolean {
  const type = (blob.type || '').toLowerCase();
  const compact = type.includes('jpeg') || type.includes('jpg') || type.includes('webp');
  return compact && blob.size > 0 && blob.size <= GALLERY_THUMB_SKIP_BYTES;
}
